// Seller Launch Hub — mock data
// Premium proptech operational data for the post-instruction workflow.

const headshot = (id) =>
  `https://images.unsplash.com/${id}?w=200&q=80&auto=format&fit=crop&crop=faces`;

export const property = {
  id: "prop-mers-2401",
  address: "12 Mersey Reach, Aigburth, Liverpool, L17 6AS",
  shortAddress: "12 Mersey Reach, Aigburth",
  region: "Merseyside",
  guidePrice: "£725,000",
  bedrooms: 4,
  bathrooms: 3,
  sqft: 2480,
  status: "Instruction Active",
  instructionWonAt: "Mon, 03 Feb 2026",
  launchTarget: "Sat, 22 Feb 2026 — 09:00",
  daysToLaunch: 6,
  hoursToLaunch: 142,
  readiness: 84,
  image:
    "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1600&q=85&auto=format&fit=crop",
  imageAlt:
    "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1600&q=85&auto=format&fit=crop",
};

export const seller = {
  id: "seller-1",
  name: "Eleanor & James Whitfield",
  initials: "EW",
  contact: "eleanor.whitfield@protonmail.com",
  responsiveness: 92,
  avatar: headshot("photo-1573496359142-b8d87734a5a2"),
};

export const leadNegotiator = {
  id: "agent-lead",
  name: "Olivia Marsh",
  initials: "OM",
  role: "Lead Negotiator",
  branch: "Liverpool — Aigburth",
  color: "violet",
  avatar: headshot("photo-1438761681033-6461ffad8d80"),
};

export const officeTeam = [
  {
    id: "agent-2",
    name: "Daniel Okafor",
    initials: "DO",
    role: "Senior Negotiator",
    color: "blue",
    avatar: headshot("photo-1500648767791-00dcc994a43e"),
    online: true,
  },
  {
    id: "agent-3",
    name: "Priya Shah",
    initials: "PS",
    role: "Listings Coordinator",
    color: "amber",
    avatar: headshot("photo-1544005313-94ddf0286df2"),
    online: true,
  },
  {
    id: "agent-4",
    name: "Marcus Reid",
    initials: "MR",
    role: "Photography & Media",
    color: "rose",
    avatar: headshot("photo-1633332755192-727a05c4013d"),
    online: false,
  },
];

// Workflow stages for the launch lifecycle
export const launchStages = [
  { id: "instruction", label: "Instruction Won", state: "complete", date: "03 Feb" },
  { id: "brochure", label: "Brochure Review", state: "active", date: "10 Feb" },
  { id: "documents", label: "Documents Collected", state: "in-progress", date: "14 Feb" },
  { id: "viewings", label: "Viewings Live", state: "upcoming", date: "22 Feb" },
  { id: "offer", label: "Under Offer", state: "upcoming", date: "—" },
];

// Right panel — Seller Readiness Score
export const readinessChecklist = [
  { id: "brochure", label: "Brochure approved", state: "complete" },
  { id: "epc", label: "EPC uploaded", state: "complete" },
  { id: "documents", label: "Documents pending", state: "warning", note: "3 of 8 missing" },
  { id: "viewing", label: "Viewing availability set", state: "in-progress", note: "Mon–Sat confirmed" },
  { id: "compliance", label: "Compliance checks", state: "complete" },
];

// At a glance
export const atAGlance = {
  brochureStatus: { label: "Approved (v3)", tone: "ok" },
  missingDocuments: { label: "3 outstanding", tone: "warn" },
  nextViewing: { label: "Sat 22 Feb · 10:30", tone: "info" },
  latestFeedback: { label: "Loved layout · concerns on service charge", tone: "info" },
  sellerResponsiveness: { label: "92% · Replies < 2h", tone: "ok" },
};

// Agent Next Action card
export const nextAction = {
  title: "Awaiting seller approval on brochure v3",
  description:
    "Eleanor confirmed she'd review by today. Final cover image revision pending sign-off.",
  ctaLabel: "Send Reminder",
  due: "Today, 17:00",
};

// Team chat messages
export const teamChatMessages = [
  {
    id: "m1",
    from: "agent-lead",
    type: "intro",
    body:
      "Welcome to your Seller Launch Hub, Eleanor. I'm Olivia, your lead negotiator. The team and I will keep everything visible and on schedule from instruction through to your launch on 22 February.",
    at: "Mon · 09:14",
  },
  {
    id: "m2",
    from: "agent-2",
    type: "intro",
    body:
      "Hi Eleanor — Daniel here, supporting on negotiations. I'll cover Olivia on Wednesdays and weekend viewings.",
    at: "Mon · 09:18",
  },
  {
    id: "m3",
    from: "agent-3",
    type: "intro",
    body:
      "Priya here — I'll be coordinating photography, the EPC and the brochure. Marcus is booked in for Thursday between 10:00–13:00 for the shoot.",
    at: "Mon · 09:22",
  },
  {
    id: "m4",
    from: "seller-1",
    type: "reply",
    body:
      "Lovely to meet you all — please send anything I need to sign off as soon as possible. We'd like to be live before Easter.",
    at: "Mon · 11:02",
  },
  {
    id: "m5",
    from: "agent-3",
    type: "file",
    body: "Brochure v3 ready for your review.",
    file: { name: "12-Mersey-Reach-Brochure-v3.pdf", size: "8.4 MB", pages: 18 },
    at: "Wed · 14:46",
  },
  {
    id: "m6",
    from: "seller-1",
    type: "reply",
    body:
      "Could we update the front cover image and mention the south-facing aspect of the garden on page 3?",
    at: "Wed · 16:11",
  },
  {
    id: "m7",
    from: "agent-lead",
    type: "reply",
    body:
      "Perfectly noted — Marcus will reshoot the cover Thursday morning and Priya will revise the wording. New version with you by Friday lunch.",
    at: "Wed · 16:18",
  },
];

// Brochure
export const brochure = {
  filename: "12-Mersey-Reach-Brochure-v3.pdf",
  version: "v3",
  uploadedAt: "Wed, 12 Feb · 14:46",
  pages: 18,
  size: "8.4 MB",
  sellerStatus: "Edits Requested",
  sellerNote:
    "Could we update the front cover image and mention the south-facing aspect of the garden on page 3?",
  thumbnail:
    "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=900&q=80&auto=format&fit=crop",
};

// Viewings
export const viewings = [
  {
    id: "v1",
    buyer: "Henderson Family",
    date: "Sat 22 Feb",
    time: "10:30",
    agent: "Olivia Marsh",
    status: "Confirmed",
    notes: "Pre-approved · cash buyer",
  },
  {
    id: "v2",
    buyer: "Mr & Mrs Akinola",
    date: "Sat 22 Feb",
    time: "12:00",
    agent: "Daniel Okafor",
    status: "Confirmed",
    notes: "Mortgage in principle",
  },
  {
    id: "v3",
    buyer: "Sophie Lin",
    date: "Sun 23 Feb",
    time: "11:15",
    agent: "Olivia Marsh",
    status: "Pending",
    notes: "Awaiting confirmation",
  },
  {
    id: "v4",
    buyer: "Robert Carter",
    date: "Mon 24 Feb",
    time: "17:30",
    agent: "Daniel Okafor",
    status: "Rescheduled",
    notes: "Moved from 25 Feb · work conflict",
  },
  {
    id: "v5",
    buyer: "Jasmine Wright",
    date: "Tue 25 Feb",
    time: "09:00",
    agent: "Olivia Marsh",
    status: "Confirmed",
    notes: "Second viewing requested",
  },
];

// Calendar — week of 17 Feb
export const calendarWeek = {
  weekLabel: "17 – 23 February 2026",
  days: ["Mon 17", "Tue 18", "Wed 19", "Thu 20", "Fri 21", "Sat 22", "Sun 23"],
  events: [
    { day: 0, start: 10, end: 12, title: "EPC Assessment", kind: "epc", agent: "EPC Co." },
    { day: 1, start: 14, end: 15, title: "Compliance Call", kind: "compliance", agent: "Priya S." },
    { day: 2, start: 9, end: 11, title: "Contractor — Garden", kind: "contractor", agent: "GreenLeaf" },
    { day: 3, start: 10, end: 13, title: "Photography Reshoot", kind: "photo", agent: "Marcus R." },
    { day: 4, start: 15, end: 16, title: "Brochure Sign-off", kind: "milestone", agent: "Eleanor W." },
    { day: 5, start: 9, end: 9.5, title: "LAUNCH LIVE", kind: "launch", agent: "All teams" },
    { day: 5, start: 10.5, end: 11.5, title: "Viewing — Henderson", kind: "viewing", agent: "Olivia M." },
    { day: 5, start: 12, end: 13, title: "Viewing — Akinola", kind: "viewing", agent: "Daniel O." },
    { day: 6, start: 11, end: 12, title: "Viewing — Lin", kind: "viewing", agent: "Olivia M." },
  ],
  hours: [9, 10, 11, 12, 13, 14, 15, 16, 17],
};

// Latest feedback
export const feedback = [
  {
    id: "f1",
    buyer: "Henderson Family",
    date: "Sat 22 Feb",
    quote: "Loved the layout and natural light, but slightly concerned about the service charge.",
    potential: "High",
    visibility: "seller",
    interest: 88,
  },
  {
    id: "f2",
    buyer: "Mr & Mrs Akinola",
    date: "Sat 22 Feb",
    quote: "Second viewing requested for next weekend — they want to bring the children.",
    potential: "High",
    visibility: "seller",
    interest: 92,
  },
  {
    id: "f3",
    buyer: "Sophie Lin",
    date: "Sun 23 Feb",
    quote:
      "Rooms feel smaller than the brochure suggests — may struggle on price, but kitchen is exceptional.",
    potential: "Medium",
    visibility: "internal",
    interest: 64,
  },
];

// Documents hub
export const sellerDocuments = [
  { id: "doc-id", name: "Photo ID", category: "Identity", status: "Approved", updated: "Mon 03 Feb" },
  { id: "doc-epc", name: "EPC Certificate", category: "Compliance", status: "Uploaded", updated: "Tue 11 Feb" },
  { id: "doc-eicr", name: "EICR Report", category: "Compliance", status: "Needs Review", updated: "Tue 11 Feb" },
  { id: "doc-lease", name: "Lease Agreement", category: "Legal", status: "Uploaded", updated: "Wed 12 Feb" },
  { id: "doc-svc", name: "Service Charge Statement", category: "Financial", status: "Missing" },
  { id: "doc-rent", name: "Ground Rent Statement", category: "Financial", status: "Missing" },
  { id: "doc-mgmt", name: "Management Pack", category: "Legal", status: "Missing" },
  { id: "doc-ta", name: "TA6 / TA10 Forms", category: "Legal", status: "Needs Review", updated: "Thu 13 Feb" },
];

// Market readiness AI insights
export const marketInsights = [
  {
    id: "i1",
    headline: "Saturday viewing slots drive 28% more enquiries",
    detail:
      "Properties launched with Saturday availability outperform mid-week launches in your postcode.",
    impact: "+28%",
    tone: "positive",
  },
  {
    id: "i2",
    headline: "Homes launched within 72h of photography see 41% higher first-week interest",
    detail: "Photographer is booked Thursday — keep the launch on Saturday to capture momentum.",
    impact: "+41%",
    tone: "positive",
  },
  {
    id: "i3",
    headline: "Pricing is in line with current Aigburth demand",
    detail:
      "£725,000 sits within 2% of comparable instructions. No re-pricing recommended at this stage.",
    impact: "On target",
    tone: "neutral",
  },
];

// Activity timeline
export const activityTimeline = [
  {
    id: "a1",
    at: "Today · 09:14",
    actor: "Olivia Marsh",
    title: "Reminder sent to seller",
    detail: "Brochure v3 sign-off requested · due 17:00 today.",
    kind: "reminder",
  },
  {
    id: "a2",
    at: "Yesterday · 16:18",
    actor: "Olivia Marsh",
    title: "Replied in team chat",
    detail: "Confirmed cover reshoot Thursday with Marcus.",
    kind: "chat",
  },
  {
    id: "a3",
    at: "Yesterday · 16:11",
    actor: "Eleanor Whitfield",
    title: "Brochure edits requested",
    detail: "Cover image + south-facing aspect note on page 3.",
    kind: "approval",
  },
  {
    id: "a4",
    at: "Wed · 14:46",
    actor: "Priya Shah",
    title: "Brochure v3 uploaded",
    detail: "12-Mersey-Reach-Brochure-v3.pdf · 8.4 MB · 18 pages.",
    kind: "upload",
  },
  {
    id: "a5",
    at: "Tue · 11:30",
    actor: "Compliance Bot",
    title: "Compliance review completed",
    detail: "AML & ID checks signed off. EICR flagged for review.",
    kind: "compliance",
  },
  {
    id: "a6",
    at: "Tue · 09:02",
    actor: "Priya Shah",
    title: "EPC certificate received",
    detail: "Rated B (84) · uploaded to Documents Hub.",
    kind: "upload",
  },
  {
    id: "a7",
    at: "Mon · 14:00",
    actor: "Sophie Lin",
    title: "Viewing requested",
    detail: "Sun 23 Feb · 11:15 · awaiting confirmation.",
    kind: "viewing",
  },
];
